'use client';
'use strict';

var classes = {"root":"m-5f93f3bb","input":"m-926b4011","track":"m-9307d992","thumb":"m-93039a1d","trackLabel":"m-8277e082"};

module.exports = classes;
//# sourceMappingURL=Switch.module.css.cjs.map
